import {FC} from "react";
import styled from "styled-components";

import { Icon } from "../../../../../../../components/atoms";

import {BankCard} from "../../../../../../../models/BankCard.model";
import { useTranslation } from "react-i18next";

const CardWrapper = styled.div`
    min-height: 172px;
    width: 100%;
    background-color: ${(theme) => theme.theme.etDark1};
    border-radius: 16px;
    display: flex;
    flex-flow: row wrap;
    padding: 16px 16px 21px;
`;

const CardDetails = styled.div`
  display: flex;
  width: 100%;
  justify-content: center;
  height: 52px;
  
  .card-logo {
    width: 52px;
    height: 52px;
    img {
      object-fit: contain;
    }  
  }
  
  .card-details {
    display: flex;
    flex-flow: row wrap;
    
    span {
      display: block;
      width: 100%;
      text-align: center;
      font-weight: 700;
      color: ${(theme) => theme.theme.Light1};
      
      &:first-child {
        font-size: 12px;
      }
      &:last-child {
        font-size: 16px;
      }
    }
  }
`;

const CardData = styled.div`
    display: flex;
  flex-flow: row wrap;
  border-bottom: 2px solid ${(theme) => theme.theme.etDark3};
  
  .data-row {
    display: flex;
    justify-content: space-between;
    align-items: center;
    #card-number {
      direction: ltr;
    }
    span {
      font-size: 14px;
      font-weight: 400;
      color: ${(theme) => theme.theme.Light1};
    }
  }
`;

type OwnProps = {
    bankCardData?: BankCard;
};

const BankCardDetails: FC<OwnProps> = ({
    bankCardData,
}) => {
    /**
     * Render Card Number
     * To split 4 digit
     */
    const {t} = useTranslation();
    const renderCardNumber = (cardNumber: any) => {
        if ( (cardNumber !== null) && typeof cardNumber === 'string') {

            const temp =  cardNumber.match(/.{1,4}/g);

            if (temp) {
                return temp.join(' ');
            }
        }

        return cardNumber;
    }

    const getBankName = () => {
        if (!bankCardData?.bankName.includes(t("deposit.addCardDialog.bank"))) {
            return t("deposit.addCardDialog.bank") + bankCardData?.bankName;
        } else {
            return bankCardData?.bankName;
        }
    }
    return(
        <CardWrapper>
            <CardDetails>
                <div className="card-logo">
                    {
                        bankCardData?.logo ? (
                            <img className="img-fluid" src={bankCardData?.logo} alt={bankCardData?.bankName} />
                        ) : (
                            <Icon name="walletOn" width="100%" height="100%" />
                        )
                    }
                </div>
                <div className="card-details">
                    <span>{getBankName()}</span>
                    <span>{bankCardData?.cardOwner}</span>
                </div>
            </CardDetails>
            <CardData>
                <div className="w-100 data-row">
                    <span>{t("deposit.addCardDialog.cardNum")}</span>
                    <span id="card-number">{renderCardNumber(bankCardData?.cardNumber)}</span>
                </div>
                <div className="w-100 data-row">
                    <span>{t("deposit.addCardDialog.nightsNum")}</span>
                    <span>{bankCardData?.shebaNumber}</span>
                </div>
            </CardData>
        </CardWrapper>
    );
};

export default BankCardDetails;
